import { MenuPageGroupDefinition } from './models/menu-page-group';
import { MenuPageItemDefinition } from './models/menu-page-item';

export const menuGroups: MenuPageGroupDefinition[] = [
    {
        name: 'Artifacts',
        column: 1
    },
    {
        name: 'Document Types and Formats',
        column: 1
    },
    {
        name: 'Distribution Resolution',
        column: 2
    },
    {
        name: 'Distribution Configuration',
        column: 2
    },
    {
        name: 'Tracking',
        column: 3
    },
    {
        name: 'Error handling',
        column: 3
    },
    {
        name: 'Connectivity',
        column: 3
    },
    {
        name: 'Status Events',
        column: 3
    },
    {
        name: 'Import and Export',
        column: 3
    },
    {
        name: "Scheduling",
        column: 3
    }
];

export const menuItems: MenuPageItemDefinition[] = [
    {
        key: 'assembly-artifacts',
        name: 'Assembly Artifacts',
        group: 'Artifacts',
        link: '/developer/assemblyartifacts'
    },
    {
        key: 'xml-artifacts',
        name: 'XML Artifacts',
        group: 'Artifacts',
        link: '/developer/xmlartifacts'
    },
    {
        key: 'nuget-feeds',
        name: 'Nuget Feeds',
        group: 'Artifacts',
        link: '/developer/nugetfeeds'
    },
    {
        key: 'context-properties',
        name: 'Context Properties',
        group: 'Artifacts',
        link: '/developer/contextproperties'
    },
    {
        key: 'document-types',
        name: 'Document Types',
        group: 'Document Types and Formats',
        link: '/developer/doctype'
    },
    {
        key: 'document-type-groups',
        name: 'Document Type Groups',
        group: 'Document Types and Formats',
        link: '/developer/doctypegroups'
    },
    {
        key: 'format-types',
        name: 'Format Types',
        group: 'Document Types and Formats',
        link: '/developer/formattypes'
    },
    {
        key: 'formats',
        name: 'Formats',
        group: 'Document Types and Formats',
        link: '/developer/formats'
    },
    {
        key: 'variants',
        name: 'Variants',
        group: 'Document Types and Formats',
        link: '/developer/variants'
    },
    {
        key: 'variant-versions',
        name: 'Variant Versions',
        group: 'Document Types and Formats',
        link: '/developer/versions'
    },
    {
        key: 'document-configurations',
        name: 'Document Configurations',
        group: 'Document Types and Formats',
        link: '/developer/docconfigs'
    },
    {
        key: 'identification-types',
        name: 'Identification Types',
        group: 'Distribution Resolution',
        link: '/developer/identification'
    },
    {
        key: 'system-init-steps',
        name: 'System Init Steps',
        group: 'Distribution Resolution',
        link: '/developer/system-init-steps'
    },
    {
        key: 'initialize-disassembler-steps',
        name: 'Initialize / Disassembler Steps',
        group: 'Distribution Resolution',
        link: '/developer/init-steps'
    },
    {
        key: 'itinerary-steps',
        name: 'Itinerary Steps',
        group: 'Distribution Resolution',
        link: '/developer/itineraries'
    },
    {
        key: 'document-type-classifiers',
        name: 'Document Type Classifiers',
        group: 'Distribution Resolution',
        link: '/developer/document-type-classifier'
    },
    {
        key: 'document-type-classifier-resolvers',
        name: 'Document Type Classifier Resolvers',
        group: 'Distribution Resolution',
        link: '/developer/document-type-classifier-resolver'
    },
    {
        key: 'xml-property-promotions',
        name: 'XML Property Promotions',
        group: 'Distribution Resolution',
        link: '/developer/xmlpropertypromotions'
    },
    {
        key: 'configuration-keys',
        name: 'Configuration Keys',
        group: 'Distribution Configuration',
        link: '/developer/configkey'
    },
    {
        key: 'batching-configurations',
        name: 'Batching Configurations',
        group: 'Distribution Configuration',
        link: '/developer/batchingconfigurations'
    },
    {
        key: 'duplicate-checks',
        name: 'Duplicate Checks',
        group: 'Distribution Configuration',
        link: '/developer/duplicate-checks'
    },
    {
        key: 'file-naming-types',
        name: 'File Naming Types',
        group: 'Distribution Configuration',
        link: '/developer/filenamingtypes'
    },
    {
        key: 'tracking-fields',
        name: 'Tracking Fields',
        group: 'Tracking',
        link: '/developer/tracking'
    },
    {
        key: 'error-codes',
        name: 'Error Codes',
        group: 'Error handling',
        link: '/developer/errorcodes'
    },
    {
        key: 'transport-types',
        name: 'Transport Types',
        group: 'Connectivity',
        link: '/developer/transport-types'
    },
    {
        key: 'integrated-ftp-providers',
        name: 'Integrated FTP Providers',
        group: 'Connectivity',
        link: '/developer/integrated-ftp-providers'
    },
    {
        key: 'system-integrated-ftp-provider',
        name: 'System Integrated FTP Provider',
        group: 'Connectivity',
        link: '/developer/system-integrated-ftp-provider'
    },
    {
        key: 'status-event-subscriptions',
        name: 'Status Event Subscriptions',
        group: 'Status Events',
        link: '/developer/statusevents'
    },
    {
        key: 'import',
        name: 'Import',
        group: 'Import and Export',
        link: '/developer/import',
        permissions: ['Developer_Action_Import']
    },
    {
        key: 'export',
        name: 'Export',
        group: 'Import and Export',
        link: '/developer/export',
        permissions: ['Developer_Action_Export']
    },
    {
        key: 'tracking-ui-actions',
        name: 'Tracking UI Actions',
        group: 'Tracking',
        link: '/developer/tracking-ui-actions'
    },
    {
        key: 'scheduler-task-handlers',
        name: 'Scheduler Task Handlers',
        group: 'Scheduling',
        link: '/developer/scheduler-task-handlers'
    }
];
